/* eslint-disable no-console */
import { KENTICO_TYPES } from 'common/consts/kentico';
import { slashesToDashes } from 'common/methods/string';
import Client from './kenticoClient';

class ProductsService {
  client = Client;

  async fetchProductByUrlSlug(slug) {
    try {
      const slugCodename = slashesToDashes(slug);

      const items = await this.client.items()
        .type(KENTICO_TYPES.PRODUCT)
        .containsFilter('elements.product_slugs', [slugCodename])
        .depthParameter(10)
        .getPromise();

      if (items.isEmpty) {
        return null;
      }
      return items.lastItem;
    } catch (error) {
      console.error('Failed to fetch product data', error);
      return null;
    }
  }
}

export default new ProductsService();



// WEBPACK FOOTER //
// ./src/services/Products.service.js